import React, { useState } from "react";
import Keeper from "../shared/Keeper";
import { StyledThumbsUp } from "../shared/styles";
import ThumbsUp from "../shared/ThumbsUp";
import { sendAppEvent } from "../../../Utils";

import {
  StyledReviewCards,
  StyledReviewCard,
  StyledKeepersBox,
  StyledExitButton,
  StyledKeepersGrid,
} from "./styles";

const ReviewBrainstorm = ({
  setKeepers,
  keepers,
  setItems,
  items,
  closeBrainstorm,
  startTime,
  endTime,
  rejected,
  setRejected,
  saved,
}) => {
  const [editing, setEditing] = useState(false);
  const minutes = Math.floor((endTime - startTime) / 1000 / 60)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor(((endTime - startTime) / 1000) % 60)
    .toString()
    .padStart(2, "0");
  const lookedAt = keepers.length + items.length + rejected.length;

  const handleExit = () => {
    sendAppEvent("Brainstorm - Screen 4 Exit Button");
    closeBrainstorm();
  };

  return (
    <div>
      <StyledReviewCards>
        <StyledReviewCard>
          <span>you looked at</span>
          <h2>{lookedAt || 0}</h2>
          <span>ideas</span>
        </StyledReviewCard>
        <StyledReviewCard>
          <span>you spent</span>
          <h2>
            {minutes || "00"}:{seconds || "00"}
          </h2>
          <span>stormin'</span>
        </StyledReviewCard>
        <StyledReviewCard>
          <span>
            {keepers.length > rejected.length
              ? "you're not picky"
              : "you're picky!"}
          </span>
          <h2>
            {keepers.length || 0}:{rejected.length || 0}
          </h2>
          <span>up:down ratio</span>
        </StyledReviewCard>
      </StyledReviewCards>
      <StyledKeepersBox>
        <h3>
          <StyledThumbsUp>
            <ThumbsUp opacity={"1"} color={"var(--grey-0)"} />
          </StyledThumbsUp>
          &nbsp;&nbsp;Keepers
        </h3>
        <StyledKeepersGrid>
          {keepers.length > 0 ? (
            keepers.map((keeper, i) => (
              <Keeper
                key={'keeper_' + i}
                content={keeper}
                index={i}
                setKeepers={setKeepers}
                keepers={keepers}
                setItems={setItems}
                items={items}
                setEditing={setEditing}
                editing={editing}
                rejected={rejected}
                setRejected={setRejected}
              />
            ))
          ) : (
            <h2>You didn't make any keepers.</h2>
          )}
        </StyledKeepersGrid>
      </StyledKeepersBox>
      {saved === false && (
        <StyledExitButton>
          <div>Save and Exit</div>
        </StyledExitButton>
      )}
      {saved !== false && (
        <StyledExitButton onClick={handleExit}>
          <div>Save and Exit</div>
        </StyledExitButton>
      )}
    </div>
  );
};

export default ReviewBrainstorm;
